function step_is_valid(step_item) {
  let result = true;

  step_item.find("input, select, textarea").each(function (index, input) {
    $(input).removeClass("invalid");
    $(input).siblings(".form-control").removeClass("invalid");
    if (!input.checkValidity()) {
      $(input).addClass("invalid");
      $(input).siblings(".form-control").addClass("invalid");
      result = false;
    }
  })

  return result;
}

function on_step_change() {
  $("[data-hide-on-step-change]").hide();
  $("[data-show-on-step-change]").show();
}

function go_to_step(step_item) {
  let steps = step_item.closest(".steps");
  steps.find("> .step").removeClass("active");
  step_item.addClass("active");
  on_step_change();
}

$(document).ready(function () {
  on_step_change();

  $(".steps > .step .next-step").click(function () {
    let steps = $(this).closest(".steps");
    let active_step = steps.find("> .step.active");

    if (step_is_valid(active_step)) {
      go_to_step(active_step.next(".step"));
    }
  })

  $("[data-step-index]").click(function () {
    let steps = $(this).closest(".steps");
    go_to_step(steps.find("> .step").eq($(this).data("step-index")));
  })
});